import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

import type { EditFormState } from "./types";

interface EditNotificationDialogProps {
  visible: boolean;
  formData: EditFormState;
  onChange: (form: EditFormState) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export function EditNotificationDialog({
  visible,
  formData,
  onChange,
  onSave,
  onCancel,
  isSaving,
}: EditNotificationDialogProps) {
  return (
    <Dialog
      header="Edit Notification"
      visible={visible}
      style={{ width: "50vw" }}
      onHide={onCancel}
      footer={
        <div className="flex gap-4 justify-end">
          <Button label="Cancel" severity="secondary" onClick={onCancel} />
          <Button label="Save" onClick={onSave} loading={isSaving} />
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <InputText
          value={formData.title}
          placeholder="Header"
          onChange={e => onChange({ ...formData, title: e.target.value })}
        />
        <InputTextarea
          value={formData.description}
          placeholder="Message"
          onChange={e => onChange({ ...formData, description: e.target.value })}
          rows={5}
        />
      </div>
    </Dialog>
  );
}
